import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Divider, Placeholder } from "semantic-ui-react";
import { useMyGlobal } from "./GlobalData";
import { FaPeopleGroup } from "react-icons/fa6";
import { slugify } from "./utility";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css/navigation';

export const PlayerCategory = () => {
    const swiperRef = useRef(null);
    const navigate = useNavigate()
    const { token, windowWidth } = useMyGlobal()
    const [categoryData, setCategoryData] = useState([])
    const itemsPerCarousel = windowWidth < 600 ? 3 : 4;
    const [isHover, setIsHover] = useState(false);

    const getCategory = async () => {
        await axios({
            method: "GET",
            url: `${process.env.REACT_APP_ERP_URL}api_web/controler/category${global.APPSUFFIX}.php/?index=6`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        })
        .then(res => {
            setCategoryData(res.data)
        })
    }

    const handleClickChild = (parent, childId) => {
        let data = parent.find(i => i.id_category_child == childId)
        data.from = 'child'
        data.selected_child = childId
        const slug = data.slug ? data.slug : slugify(data.category_name)
        navigate(`/product_list/${childId}/${slug}`, { state: data })
    }

    useEffect(() => {
        getCategory()
    }, [])

    return (
        <Container fluid className="mt-5 mb-4">
            <React.Fragment>
                <Row>
                    <Col md={12} className="text-start">
                        <div className="text-center">
                            <FaPeopleGroup className="fs-2" />
                            <Divider horizontal>
                                <h1 className="fs-6">Signature Player</h1>
                            </Divider>
                        </div>
                    </Col>
                </Row>

                <div
                    className="mt-3"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        position: 'relative',
                        padding: windowWidth < 768 ? '0' : '0 50px'
                        
                    }}
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                >

                    {/* LEFT */}
                    {windowWidth >= 768 && (
                        <div
                            style={{
                                position: 'absolute',
                                left: '0px',
                                top: '50%',
                                transform: isHover 
                                            ? 'translateY(-50%) translateX(0)' 
                                            : 'translateY(-50%) translateX(-10px)',
                                zIndex: 10,

                                opacity: isHover ? 1 : 0,
                                transition: '0.3s',

                                cursor: 'pointer',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                            }}
                            onClick={() => swiperRef.current?.slidePrev()}
                        >
                            <FaChevronLeft size={20} />
                        </div>
                    )}

                    {/* SWIPER */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <Swiper
                            modules={[Autoplay]}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            loop={true}
                            slidesPerGroup={1}
                            spaceBetween={16}
                            grabCursor={true}


                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true
                            }}

                            breakpoints={{
                                0: { slidesPerView: 3 },
                                768: { slidesPerView: 4 }
                            }}

                            speed={800}
                            
                            style={{ width: '100%' }}
                            slidesOffsetBefore={16}
                            slidesOffsetAfter={16}
                        >
                            {
                                categoryData.length > 0 ? (
                                    categoryData.map((item, i) => (
                                        <SwiperSlide key={`${item.id_category_child}-${i}`}>
                                            <div style={{paddingTop: "1.3em", paddingBottom: "1.5em", paddingLeft :"0rem", paddingRight :"0rem"}}>
                                                <Card
                                                    onClick={() => handleClickChild(categoryData, item.id_category_child)}
                                                    style={{ cursor: 'pointer', alignContent: 'center' }}
                                                    className="zoom-2"
                                                >
                                                    <Image
                                                        rounded
                                                        src={item.thumbnail_image ? item.thumbnail_image : 'https://via.placeholder.com/350x600.png'}
                                                        fluid
                                                    />
                                                </Card>
                                            </div>
                                        </SwiperSlide>
                                    ))
                                ) : (
                                    [...Array(itemsPerCarousel)].map((_, i) => (
                                        <SwiperSlide key={i}>
                                            <Card style={{ alignContent: 'center' }}>
                                                <div
                                                    className="w-100"
                                                    style={{ aspectRatio: '350 / 600' }}
                                                >
                                                    <Placeholder fluid style={{ width: '100%', height: '100%' }}>
                                                        <Placeholder.Image rectangular />
                                                    </Placeholder>
                                                </div>
                                            </Card>
                                        </SwiperSlide>
                                    ))
                                )
                            }
                        </Swiper>
                    </div>

                    {/* RIGHT ARROW */}
                    {windowWidth >= 768 && (
                        <div
                            style={{
                                position: 'absolute',
                                right: '0px',
                                top: '50%',
                                transform: isHover 
                                            ? 'translateY(-50%) translateX(0)' 
                                            : 'translateY(-50%) translateX(10px)',
                                zIndex: 10,

                                opacity: isHover ? 1 : 0,
                                transition: '0.3s',

                                cursor: 'pointer',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                            }}
                            onClick={() => swiperRef.current?.slideNext()}
                        >
                            <FaChevronRight size={20} />
                        </div>
                    )}

                </div>
            </React.Fragment>
        </Container>
    )
}